import BaseChangeset from 'common/changesets/base';
import type { UserKind } from 'common/enums/user-kind.enum';

export type RegisterDTO = {
  id?: string;
  kind?: UserKind;
  privacyPolicyAgreement: boolean;
  termsAgreement: boolean;
  newsAgreement: boolean;
  applicant: {
    firstName: string;
    lastName: string;
    email: string;
    phone: string;
    registerNumber?: string;
    companyNumber?: string;
    companyName?: string;
    institution?: string;
    cooperationAgreement?: boolean;
  };
};

export class RegisterChangeset extends BaseChangeset<RegisterDTO> {}
